import VuetifyAudio from './src/vuetifyaudio.vue'

export default VuetifyAudio
export { VuetifyAudio }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify-audio/index.js
// module id = null
// module chunks = 